export const AvailabilityCalendarModel = {
  brandSlug: '',
  brandCSS: '/etc.clientlibs/mi-aem-common-spa/brand-config.{brandCode}.css',
  staticComponentClientLibsCSS: '/etc.clientlibs/mi-aem-shop-spa/clientlibs/clientlib-static-component.min.css',
  dataLayerInitializationScript:
    '/etc.clientlibs/core/wcm/components/commons/datalayer/v1/clientlibs/core.wcm.components.commons.datalayer.v1.js',
  componentsResourceTypes: [
    'mi-aem-shop-spa/components/content/availabilitycalendar/v1/availabilitycalendar',
    'mi-aem-shop-spa/components/content/searchform/v1/searchform',
    'mi-aem-homepage-spa/components/content/universal-footer',
    'mcom-book-spa/components/prebooking/hotelheader',
    'mi-aem-common-spa/components/common/staticwrapper',
    'core/wcm/components/page/v2/page',
    'wcm/foundation/components/responsivegrid',
    'nt:unstructured',
    'mi-aem-common-spa/components/xfpage',
    'mi-aem-shop-spa/components/content/merchbanner/v1/merchbanner',
    'mi-aem-shop-spa/components/structure/headlessnextjspage',
    'mi-aem-common-spa/components/experiencefragment',
  ],
  htmlPageItems: [],
  metaNames: [
    {
      name: 'keyword',
      value: '',
    },
    {
      name: 'msapplication-TileColor',
      value: '',
    },
    {
      name: 'msapplication-TileImage',
      value: '',
    },
    {
      name: 'onLoadLightboxURI',
      value: '',
    },
    {
      name: 'description',
      value: '',
    },
    {
      name: 'showLightboxOnLoad',
      value: '',
    },
    {
      name: 'robots',
      value: 'noindex,nofollow',
    },
  ],
  language: 'en-US',
  title: 'Find Dates & Rates that Work for You',
  dataLayerType: 'traditional',
  authorMode: '',
  cssClassNames: 'headlessnextjspage remotepagenext page basicpage',
  cqType: 'mi-aem-shop-spa/components/structure/headlessnextjspage',
  dataLayerLaunchScript:
    'https://assets.adobedtm.com/697d0c070f1e/16ad26f0160a/launch-ENaaca933107c74c4eb05514750752e1b8-staging.min.js',
  favIcon: '',
  hreflangList: [],
  cqHierarchyType: 'page',
  currentPagePath: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content',
  lastModifiedDate: 1744966870496,
  canonical: '',
  cqItems: {
    root: {
      ':items': {
        responsivegrid: {
          ':items': {
            merchbanner_696367081: {
              ':type': 'mi-aem-shop-spa/components/content/merchbanner/v1/merchbanner',
              dataLayer: {
                'merchbanner-2fd03dee2e': {
                  '@type': 'mi-aem-shop-spa/components/content/merchbanner/v1/merchbanner',
                  'repo:modifyDate': '2025-04-18T09:01:10Z',
                },
              },
              id: 'merchbanner-2fd03dee2e',
            },
            availabilitycalendar: {
              avgNightlyCostTabText: 'Average Nightly Cost',
              tenThousandLabel: '',
              includesLabel: 'Includes',
              dailyLabel: 'daily',
              allRatesAdditionalLabel: 'All rates subject to an additional',
              yearSearchLabel: 'Year',
              allRatesIncludeLabel: 'All rates include',
              feeLabel: 'Fee',
              ':type': 'mi-aem-shop-spa/components/content/availabilitycalendar/v1/availabilitycalendar',
              localDateFormat: 'MM/DD/YYYY',
              avgNightlyCostPlaceholderText: '{X} Night Average Total',
              adfButtonText: 'Continue',
              forLabel: 'for',
              adfAlertBody: [
                {
                  adfAlertCodeListItems: [
                    {
                      adfAlertMessage:
                        'The group code you entered has fewer than seven characters. Please verify the code.',
                      adfAlertType: 'error-sev2',
                      adfAlertCode: 'group.code.fewer.than.7.char.error.text',
                    },
                  ],
                  adfAlertMsgTypeName: 'groupCodeHasFewerCharacters',
                },
                {
                  adfAlertCodeListItems: [
                    {
                      adfAlertMessage:
                        'Flexible date searches cannot be completed requesting more than 3 rooms. Please revise your search.',
                      adfAlertType: 'error-sev2',
                      adfAlertCode: 'flexible.date.room.count.invalid',
                    },
                  ],
                  adfAlertMsgTypeName: 'tooManyRoomsForFlexibleDates',
                },
                {
                  adfAlertCodeListItems: [
                    {
                      adfAlertMessage:
                        'Let’s try that again: Be sure that children’s ages are between less than 1 (“< 1”) and 17 years.',
                      adfAlertType: 'error-sev2',
                      adfAlertCode: 'children.age.non.numeric.invalid',
                    },
                  ],
                  adfAlertMsgTypeName: 'childrenAgeNonNumericInvalid',
                },
                {
                  adfAlertCodeListItems: [
                    {
                      adfAlertMessage: 'Your Check-in date cannot be more than',
                      adfAlertType: 'error-sev2',
                      adfAlertCode: 'checkin.date.future.not.allowed.invalid',
                    },
                  ],
                  adfAlertMsgTypeName: 'checkInDateMoreThanError',
                },
                {
                  adfAlertCodeListItems: [
                    {
                      adfAlertMessage: 'Corporate/Promotional codes are between 2-9 characters.',
                      adfAlertType: 'error-sev2',
                    },
                  ],
                  adfAlertMsgTypeName: 'corpCodeInvalidCharLength',
                },
                {
                  adfAlertCodeListItems: [
                    {
                      adfAlertMessage: 'Please select a date to proceed',
                      adfAlertType: 'error-sev2',
                    },
                  ],
                  adfAlertMsgTypeName: 'noInputDateSelected',
                },
                {
                  adfAlertCodeListItems: [
                    {
                      adfAlertMessage:
                        'The Corporate/promotional code you entered contains an invalid character. Please enter characters of the Latin alphabet only',
                      adfAlertType: 'error-sev2',
                      adfAlertCode: 'corporateCode.format.invalid',
                    },
                  ],
                  adfAlertMsgTypeName: 'corporateCodeFormatInvalid',
                },
                {
                  adfAlertCodeListItems: [
                    {
                      adfAlertMessage:
                        'Flexible date searches cannot be completed requesting more than 3 rooms. Please revise your search.',
                      adfAlertType: 'error-sev2',
                      adfAlertCode: 'room.count.between3and10.invalid',
                    },
                  ],
                  adfAlertMsgTypeName: 'roomCountBetween3and10Invalid',
                },
                {
                  adfAlertCodeListItems: [
                    {
                      adfAlertMessage:
                        'Flexible date searches cannot be completed requesting more than 3 rooms. Please revise your search.',
                      adfAlertType: 'error-sev2',
                      adfAlertCode: 'flexible.date.room.count.invalid',
                    },
                  ],
                  adfAlertMsgTypeName: 'flexibleDateRoomCountInvalid',
                },
                {
                  adfAlertCodeListItems: [
                    {
                      adfAlertMessageText: 'Travel Agents',
                      adfAlertMessage:
                        'Please sign into the Travel Agents site to book this rate. To use a different rate, clear the corporate code and start your search again. Already signed in? Try switching  browsers.',
                      adfAlertType: 'error-sev2',
                      adfAlertMessageRedirection: 'http://www.travelagents.marriott.com',
                      adfAlertCode: 'corpCode.travel.agents.error',
                    },
                  ],
                  adfAlertMsgTypeName: 'corpCodeTravelAgentsError',
                },
                {
                  adfAlertCodeListItems: [
                    {
                      adfAlertMessageText: 'Group Partners',
                      adfAlertMessage:
                        'Please sign into the Group Partners site to book this rate. To use a different rate, clear the corporate code and start your search again. ',
                      adfAlertType: 'error-sev2',
                      adfAlertMessageRedirection: 'http://www.grouppartners.marriott.com',
                      adfAlertCode: 'corpCode.group.partners.error',
                    },
                  ],
                  adfAlertMsgTypeName: 'corpCodeGroupPartnersError',
                },
                {
                  adfAlertCodeListItems: [
                    {
                      adfAlertMessage:
                        'This property is for adults only. To continue, please set the number of children in your party to zero.',
                      adfAlertType: 'error-sev2',
                      adfAlertCode: 'adults.only.property.child.count.greater.than.zero.error.text',
                    },
                  ],
                  adfAlertMsgTypeName: 'adultsOnlyPropertyChildCountIsGreaterThanZero',
                },
              ],
              avgNightlyCostLegalText:
                'Average room cost is the average of the lowest cost per night per room for the number of nights requested; Nightly rates may vary during your stay. Other rates may be offered as you proceed with your reservation. Room rates do not include taxes and fees in most markets.',
              notAvailableForCheckInText: 'Not available for check-in',
              pointsLegalText:
                'Total number of points reflects the sum of the lowest nightly point redemption rate across all rooms requested for the entire stay. Other redemption rates may be offered as you proceed with your reservation. Using your points will cover your room charge and tax; additional service charges and resort fees will be applied where applicable.',
              lowPriceIndicator: 'LOW',
              totalPerRoom: 'per room for',
              avgPerNightLabel: 'Avg/night',
              months: 'January,February,March,April,May,June,July,August,September,October,November,December',
              millionLabel: 'M',
              totalRoomCostTabText: 'Total Room Cost',
              resortLabel: 'Resort',
              destinationAmenityLabel: 'Destination Amenity',
              weekdays: 'S,M,T,W,T,F,S',
              perNight: 'per night',
              totalRoomCostPlaceholderText: '{X} Night Room Total',
              night: 'night',
              currencyLabel: '',
              rateUnavailableText: 'Rate Unavailable',
              avgTotalCostLegalText:
                'Total room cost is the sum of the lowest nightly costs per room for the number of nights requested. Other rates may be offered as you proceed with your reservation. Room rates do not include taxes and fees in most markets.',
              ratesUnavailableMobile: 'Not available for check in. Please select another date',
              surchargeTooltipHeadingLabel: 'Surcharge for Ordinance Costs',
              totalLabel: 'total',
              totalFor: 'total for',
              disableAvgNightlyCostSection: false,
              pointsLabel: 'Points',
              thousandLabel: 'K',
              firstDayOfWeek: '0',
              adfSelectionSummaryFormat: 'MMM D',
              nights: 'nights',
              alertMsgForNoDateSelection: 'Please select a date to proceed.',
              disableTotalRoomCostSection: false,
              usePointsCertificates: 'Use Points/Awards',
            },
            hotelheader_copy: {
              componentId: 'brand_bar',
              dataLayer: {
                'hotelheader-51bfcacd48': {
                  '@type': 'mcom-book-spa/components/prebooking/hotelheader',
                  'repo:modifyDate': '2025-04-18T09:01:10Z',
                },
              },
              hotelDetailsLabel: 'Hotel Details',
              disableHotelHeaderAndReviewLinks: false,
              viewDetailsLabel: 'View Details',
              phoneText: 'Phone Number',
              saveLabel: 'Save',
              ':type': 'mcom-book-spa/components/prebooking/hotelheader',
              pageType: 'rlm',
              reviews: 'reviews',
              reviewUrl: '/en-us/hotels/{property-name}/reviews/',
              referencePathA: '/content/experience-fragments/mcom-book-spa/us/en/site/property-codes/master',
              componentTitle: '',
              styleclass: 'color-scheme7',
              id: 'hotelheader-51bfcacd48',
              savedLabel: 'Saved',
              propertyCodes: {
                ':type': 'mcom-book-spa/components/propertycodes',
                pageType: '',
                dataLayer: {
                  'propertycodes-8f9707e683': {
                    '@type': 'mcom-book-spa/components/propertycodes',
                    'repo:modifyDate': '2025-04-17T06:22:29Z',
                  },
                },
                componentTitle: '',
                id: 'propertycodes-8f9707e683',
                villaResidenceAndGuestConfigList: [
                  {
                    villaPropertyCode: 'MEXRR',
                    guestRoomPropertyCode: 'MEXRZ',
                  },
                  {
                    villaPropertyCode: 'MCORO',
                    guestRoomPropertyCode: 'MCORZ',
                  },
                  {
                    villaPropertyCode: 'BDARX',
                    guestRoomPropertyCode: 'BDAXR',
                  },
                  {
                    villaPropertyCode: 'PLSRR',
                    guestRoomPropertyCode: 'PLSRT',
                  },
                  {
                    villaPropertyCode: 'SJDLS',
                    guestRoomPropertyCode: 'SJDLC',
                  },
                  {
                    villaPropertyCode: 'SJDRR',
                    guestRoomPropertyCode: 'SJDZR',
                  },
                  {
                    villaPropertyCode: 'FAOWR',
                    guestRoomPropertyCode: 'FAOWH',
                  },
                  {
                    villaPropertyCode: 'SJUDB',
                    guestRoomPropertyCode: 'SJUDO',
                  },
                  {
                    villaPropertyCode: 'ALCFV',
                    guestRoomPropertyCode: 'ALCFP',
                  },
                  {
                    villaPropertyCode: 'LIRRN',
                    guestRoomPropertyCode: 'LIRRZ',
                  },
                  {
                    villaPropertyCode: 'ASEWR',
                    guestRoomPropertyCode: 'ASEWH',
                  },
                  {
                    villaPropertyCode: 'FAOLC',
                    guestRoomPropertyCode: 'FAOPL',
                  },
                  {
                    villaPropertyCode: 'HNLRB',
                    guestRoomPropertyCode: 'HNLBR',
                  },
                  {
                    villaPropertyCode: 'PHXPC',
                    guestRoomPropertyCode: 'PHXLC',
                  },
                  {
                    villaPropertyCode: 'PUJRX',
                    guestRoomPropertyCode: 'PUJXR',
                  },
                ],
                bulgariPropertyCodes: [
                  {
                    redirectUrl: '/milan',
                    marshaCode: 'milbg',
                  },
                  {
                    redirectUrl: '/london',
                    marshaCode: 'lonbg',
                  },
                  {
                    redirectUrl: '/bali',
                    marshaCode: 'dpsbg',
                  },
                  {
                    redirectUrl: '/beijing',
                    marshaCode: 'bjsbg',
                  },
                  {
                    redirectUrl: '/dubai',
                    marshaCode: 'dxbbg',
                  },
                  {
                    redirectUrl: '/shanghai',
                    marshaCode: 'shabg',
                  },
                  {
                    redirectUrl: '/paris',
                    marshaCode: 'parbg',
                  },
                  {
                    redirectUrl: '/tokyo',
                    marshaCode: 'tyobt',
                  },
                  {
                    redirectUrl: '/rome',
                    marshaCode: 'rombg',
                  },
                ],
              },
              disableReviews: false,
              altText: 'Courtyard',
              millionLabel: 'M',
              starsOutOfText: 'stars out of',
              overridePropertyCountry: 'false',
              reviewsLabel: '{xx} reviews',
              thousandLabel: 'K',
              fileReference: {
                altText: 'adf',
                assetPath: 'https://cache.marriott.com/is/image/marriotts7prod/cy-courtyard-logo-white-hori-41917',
                dynamic: true,
                renditions: [
                  {
                    renditionPath:
                      '/content/dam/marriott-digital/cy/global-property-shared/en_us/logo/assets/cy-courtyard-logo-white-hori-41917.png',
                    mediaValue: '1200px',
                    width: 0,
                    dynamic: true,
                    damPath:
                      '/content/dam/marriott-digital/cy/global-property-shared/en_us/logo/assets/cy-courtyard-logo-white-hori-41917.png',
                    mediaQuery: 'min-width',
                    height: 0,
                  },
                  {
                    renditionPath:
                      '/content/dam/marriott-digital/cy/global-property-shared/en_us/logo/assets/cy-courtyard-logo-white-hori-41917.png',
                    mediaValue: '768px',
                    width: 0,
                    dynamic: true,
                    damPath:
                      '/content/dam/marriott-digital/cy/global-property-shared/en_us/logo/assets/cy-courtyard-logo-white-hori-41917.png',
                    mediaQuery: 'min-width',
                    height: 0,
                  },
                  {
                    renditionPath:
                      '/content/dam/marriott-digital/cy/global-property-shared/en_us/logo/assets/cy-courtyard-logo-white-hori-41917.png',
                    mediaValue: '576px',
                    width: 0,
                    dynamic: true,
                    damPath:
                      '/content/dam/marriott-digital/cy/global-property-shared/en_us/logo/assets/cy-courtyard-logo-white-hori-41917.png',
                    mediaQuery: 'max-width',
                    height: 0,
                  },
                ],
                damPath:
                  '/content/dam/marriott-digital/cy/global-property-shared/en_us/logo/assets/cy-courtyard-logo-white-hori-41917.png',
              },
            },
            searchform_copy: {
              maxGuestPerRoom: '8',
              cancel: 'Cancel',
              nightCountIncreaseLabel: 'night count increase',
              roomsGuestsHeadShortLabel: 'Rooms & Guests',
              flexibleDates: 'Flexible Dates',
              recentSearchesHeading: 'Recent Searches',
              flexibleDateFormatLabel: 'MMMM YYYY',
              dateFormat: 'ddd, MMM D',
              destinationSearchResult:
                'There are {x} search results. Keyboard users, use up and down arrows to review and enter to select. Touch device users, explore by touch or with swipe gestures.',
              featuredDestinationsXFPath:
                '/content/experience-fragments/mcom-common/global/en-us/Search/Featured_Destinations/master',
              variation: 'property',
              disableTopDestination: 'false',
              collapseOnPageLoad: false,
              ':type': 'mi-aem-shop-spa/components/content/searchform/v1/searchform',
              children: 'Children',
              disableFloatingBehavior: 'false',
              roomShortLabel: 'Room',
              collapseWhenUserUpdates: false,
              currentLocationText: 'Search from current location below.',
              flexibleTabText: 'Flexible Dates',
              edit: 'Edit',
              specialRatesPoints: 'Special Rates/Points',
              night: 'night',
              maxNumberOfNights: '9',
              enableNewSearch: 'false',
              travelMonthDesktop: 'Which month do you want to travel ?',
              howManyNights: 'How many nights?',
              roomListItems: [
                {
                  roomQuantity: '1',
                },
                {
                  roomQuantity: '2',
                },
                {
                  roomQuantity: '3',
                },
              ],
              exactDatesTabText: 'Specific Dates',
              mobileDateFormatLabel: 'DD MMM',
              clearRecentLabel: 'Clear Recents',
              nightCountDecreaseLabel: 'night count decrease',
              flexible: 'Flexible',
              enableOverlayTopWithVideo: 'false',
              reset: 'Reset',
              guest: 'guest',
              childAgeRequired: 'Child {x}: Age (Required)',
              ratesLabel: 'Rates',
              weekdaysShort: 'Sun,Mon,Tue,Wed,Thu,Fri,Sat',
              topDestinationslistItems: [
                {
                  topDestinationField: 'Orlando, Florida',
                },
                {
                  topDestinationField: 'Atlanta, Georgia',
                },
                {
                  topDestinationField: 'New York, NY',
                },
                {
                  topDestinationField: 'Miami, Florida',
                },
                {
                  topDestinationField: 'Nashville, Tennessee',
                },
              ],
              checkInLabel: 'CHECK IN',
              addCorpOrPromoCode: 'Enter Code',
              alternateDateFormat: 'NA',
              enableRedeemPoints: 'false',
              marriottShopPage: 'true',
              dateFormatLanguageLabel: 'en-gb',
              myDatesFlexibleLabel: 'My dates are flexible',
              disableUsePointCertificates: false,
              roomsGuestsHead: 'Rooms & Guests',
              localDateFormat: 'MM/DD/YYYY',
              showDatesOnMobile: 'true',
              ratesShopPageHeader: 'SPECIAL RATES',
              applyLabel: 'Apply',
              placeholderTextPopularDestination: 'Popular Destinations',
              selectOneRateLabel: 'Select one rate',
              lessThanLabel: 'Less than 1',
              editField: 'Edit',
              firstDayOfWeek: '0',
              checkOutLabel: 'CHECK OUT',
              monthsShort: 'Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec',
              searchGuestShortLabel: 'Guest',
              selectAMonth: 'Select a month',
              disableRecentlySearched: 'false',
              disableRecentlyViewed: 'false',
              rooms: 'Rooms',
              placeholderTextDesktop: 'Where can we take you?',
              enableFlexibleSearch: 'true',
              yearSearchLabel: 'Year',
              searchViewType: 'defaultview',
              findHotelLabel: 'Update Search',
              ageLabel: 'Age',
              domesticDestinationsXFPath:
                '/content/experience-fragments/mcom-common/global/en-us/Search/Domestic_Destinations/master',
              currentLocationLabel: 'Current Location',
              add: 'Add',
              hideFlexibleDatesCheckbox: 'false',
              datesPlaceholderText: 'Add Date',
              flexibleAlertMessage:
                'Flexible date searches cannot be completed requesting more than 3 rooms. Please revise your search',
              months: 'January,February,March,April,May,June,July,August,September,October,November,December',
              enableAdfSearchForm: true,
              enablePadding: 'true',
              maxGuestsMsg: 'Max: {x} total guests/room',
              weekdays: 'S,M,T,W,T,F,S',
              done: 'Done',
              recentlyViewedHeading: 'RECENTLY VIEWED',
              noResultFound: 'No result found.',
              submitAction: 'default',
              componentErrorMessage:
                'We are currently unable to display the information you requested. Please try again in few moments',
              stayDates: 'Dates',
              adults: 'Adults',
              destination: 'Destination',
              maxChildAge: '17',
              remove: 'Remove',
              ageBasedRatesLabel: 'Age-based rates may be available',
              isDateReversed: false,
              roomsShortLabel: 'Rooms',
              render: 'server',
              orderingRecentlySearchedAndViewed: 'recentSearch',
              specialRatesListItems: [
                {
                  specialRatesCode: 'none',
                  promoCodeEnable: 'false',
                  specialRateslabel: 'Lowest Regular Rate',
                },
                {
                  specialRatesCode: 'aaa',
                  promoCodeEnable: 'false',
                  specialRateslabel: 'AAA/CAA',
                },
                {
                  specialRatesCode: 'S9R',
                  promoCodeEnable: 'false',
                  specialRateslabel: 'Senior Discount',
                },
                {
                  specialRatesCode: 'gov',
                  promoCodeEnable: 'false',
                  specialRateslabel: 'Government & Military',
                },
                {
                  specialRatesCode: 'corp',
                  promoCodeEnable: 'false',
                  specialRateslabel: 'Corp/Promo Code',
                },
              ],
              weekdaysLong: 'Sunday,Monday,Tuesday,Wednesday,Thursday,Friday,Saturday',
              hideDestination: 'true',
              usePointsConfirmMessage:
                'Marriott Bonvoy points are not available for use when requesting more than 3 rooms.  Click "OK" to request a special group room rate. Click "Cancel" to revise your search.',
              placeholderTextMobile: 'Where next?',
              clear: 'Clear Dates',
              searchGuestsShortLabel: 'Guests',
              enableOverlap: 'false',
              enableOverlapTop: 'true',
              room: 'Room',
              specialRatesShopPageLabel: 'Special Rates',
              nights: 'nights',
              guests: 'guests',
              usePointsCertificates: 'Use Points/Awards',
            },
            experiencefragment: {
              configured: true,
              ':items': {
                'cq:metadata': {
                  'min-cols': '1',
                  ':type': 'nt:unstructured',
                  'max-cols': '1',
                },
                root: {
                  ':items': {
                    responsivegrid: {
                      ':items': {
                        universal_footer: {
                          findhelpItems: [
                            {
                              linkLabel: 'Help & Contact Us',
                              openInaNewTab: 'false',
                              linkURL: 'https://help.marriott.com/s/',
                            },
                            {
                              linkLabel: 'Look Up Reservation',
                              openInaNewTab: 'false',
                              linkURL: '/reservation/lookupReservation.mi',
                            },
                            {
                              linkLabel: 'Global Reservation Phone Numbers',
                              openInaNewTab: 'false',
                              linkURL: '/help/global-phone-reservation-numbers.mi',
                            },
                            {
                              linkLabel: 'Book Here, Benefit Now',
                              openInaNewTab: 'false',
                              linkURL: '/online-hotel-booking.mi#bestrate',
                            },
                            {
                              linkLabel: 'Best Rate Guarantee Form',
                              openInaNewTab: 'false',
                              linkURL: '/look/claimForm.mi',
                            },
                            {
                              linkLabel: 'Missing Stay Form',
                              openInaNewTab: 'false',
                              linkURL: '/loyalty/myAccount/missingStayRequest.mi',
                            },
                            {
                              linkLabel: 'Site Map',
                              openInaNewTab: 'false',
                              linkURL: '/sitemap.mi',
                            },
                          ],
                          regions: {
                            column1: {
                              Americas: [
                                {
                                  linkLabel: 'English',
                                  openinnewwtab: false,
                                  linkURL: '/default.mi',
                                },
                                {
                                  linkLabel: 'Español',
                                  openinnewwtab: false,
                                  linkURL: 'http://www.espanol.marriott.com/default.mi',
                                },
                                {
                                  linkLabel: 'Français',
                                  openinnewwtab: false,
                                  linkURL: 'http://www.marriott.fr/default.mi',
                                },
                                {
                                  linkLabel: 'Português',
                                  openinnewwtab: false,
                                  linkURL: 'http://www.marriott.com.br/default.mi',
                                },
                              ],
                            },
                            column3: {
                              Europe: [
                                {
                                  linkLabel: 'Dansk',
                                  openinnewwtab: false,
                                  linkURL: 'https://www.marriott.com/da/default.mi',
                                },
                                {
                                  linkLabel: 'Deutsch',
                                  openinnewwtab: false,
                                  linkURL: 'http://www.marriott.de/default.mi',
                                },
                                {
                                  linkLabel: 'Español',
                                  openinnewwtab: false,
                                  linkURL: 'http://www.espanol.marriott.com/default.mi',
                                },
                                {
                                  linkLabel: 'Français',
                                  openinnewwtab: false,
                                  linkURL: 'http://www.marriott.fr/default.mi',
                                },
                                {
                                  linkLabel: 'Ελληνικά',
                                  openinnewwtab: false,
                                  linkURL: 'https://www.marriott.com/el/default.mi',
                                },
                                {
                                  linkLabel: 'Italiano',
                                  openinnewwtab: false,
                                  linkURL: 'http://www.marriott.it/default.mi',
                                },
                                {
                                  linkLabel: 'Nederlands',
                                  openinnewwtab: false,
                                  linkURL: 'https://www.marriott.com/nl/default.mi',
                                },
                                {
                                  linkLabel: 'Norsk',
                                  openinnewwtab: false,
                                  linkURL: 'http://www.marriott.com/no',
                                },
                                {
                                  linkLabel: 'Русский',
                                  openinnewwtab: false,
                                  linkURL: 'http://www.marriott.com.ru/default.mi',
                                },
                                {
                                  linkLabel: 'Português',
                                  openinnewwtab: false,
                                  linkURL: 'http://www.marriott.com.br/default.mi',
                                },
                                {
                                  linkLabel: 'Polski',
                                  openinnewwtab: false,
                                  linkURL: 'https://www.marriott.com/pl-pl/default.mi',
                                },
                                {
                                  linkLabel: 'Suomi',
                                  openinnewwtab: false,
                                  linkURL: 'https://www.marriott.com/fi/default.mi',
                                },
                                {
                                  linkLabel: 'Svenska',
                                  openinnewwtab: false,
                                  linkURL: 'https://www.marriott.com/sv/default.mi',
                                },
                                {
                                  linkLabel: 'Türkçe',
                                  openinnewwtab: false,
                                  linkURL: 'https://www.marriott.com/tr-tr/default.mi',
                                },
                                {
                                  linkLabel: 'English',
                                  openinnewwtab: false,
                                  linkURL: 'http://www.marriott.co.uk/default.mi',
                                },
                              ],
                            },
                            column2: {
                              'Asia and Oceania': [
                                {
                                  linkLabel: 'English',
                                  openinnewwtab: false,
                                  linkURL: 'http://www.marriott.com/default.mi',
                                },
                                {
                                  linkLabel: 'Bahasa Indonesia',
                                  openinnewwtab: false,
                                  linkURL: 'http://www.marriott.com/id/default.mi',
                                },
                                {
                                  linkLabel: '中文',
                                  openinnewwtab: false,
                                  linkURL: 'http://www.marriott.com.cn/default.mi',
                                },
                                {
                                  linkLabel: '日本語',
                                  openinnewwtab: false,
                                  linkURL: 'http://www.marriott.co.jp/default.mi',
                                },
                                {
                                  linkLabel: '한국어',
                                  openinnewwtab: false,
                                  linkURL: 'http://www.marriott.co.kr/default.mi',
                                },
                                {
                                  linkLabel: 'ภาษาไทย',
                                  openinnewwtab: false,
                                  linkURL: 'http://www.marriott.com/th/default.mi',
                                },
                                {
                                  linkLabel: 'Tiếng Việt',
                                  openinnewwtab: false,
                                  linkURL: 'https://www.marriott.com/vi/default.mi',
                                },
                              ],
                              International: [
                                {
                                  linkLabel: 'English',
                                  openinnewwtab: false,
                                  linkURL: '/default.mi',
                                },
                                {
                                  linkLabel: 'اللغة العربية',
                                  openinnewwtab: false,
                                  linkURL: 'http://www.arabic.marriott.com/default.mi',
                                },
                                {
                                  linkLabel: 'עברית',
                                  openinnewwtab: false,
                                  linkURL: 'https://www.marriott.com/he/default.mi',
                                },
                              ],
                            },
                          },
                          ourCompanyItems: [
                            {
                              linkLabel: 'About Marriott International',
                              openInaNewTab: 'true',
                              linkURL: '/marriott/aboutmarriott.mi',
                            },
                            {
                              linkLabel: 'Careers',
                              openInaNewTab: 'true',
                              linkURL: 'https://careers.marriott.com/',
                            },
                            {
                              linkLabel: 'Investor Relations',
                              openInaNewTab: 'true',
                              linkURL: 'https://marriott.gcs-web.com/',
                            },
                            {
                              linkLabel: 'News',
                              openInaNewTab: 'true',
                              linkURL: 'https://news.marriott.com/',
                            },
                            {
                              linkLabel: 'CEO Tony Capuano’s Blog',
                              openInaNewTab: 'true',
                              linkURL: 'https://www.linkedin.com/in/anthony-capuano-a68390bb/',
                            },
                            {
                              linkLabel: 'Our Stories',
                              openInaNewTab: 'true',
                              linkURL: 'https://stories.marriott.com/',
                            },
                            {
                              linkLabel: 'Digital Accessibility',
                              openInaNewTab: 'false',
                              linkURL: '/digital-accessibility.mi',
                            },
                          ],
                          dataLayer: {
                            'universal-footer-c2b789a687': {
                              '@type': 'mi-aem-homepage-spa/components/content/universal-footer',
                              'repo:modifyDate': '2025-01-22T12:54:25Z',
                            },
                          },
                          resourceProperties: {
                            ourCompanyTitle: 'Our Company',
                            trackingDescription: 'expandedFooter',
                            textIsRich: 'true',
                            impressionTrack: 'false',
                            'sling:resourceType': 'mi-aem-homepage-spa/components/content/universal-footer',
                            title: 'Select your language',
                            destinationState: 'default',
                            variation: 'expanded',
                            privacyTitle: 'Privacy & Terms',
                            languagePath: '/content/dam/mi-aem-homepage-spa/language-selector-cf',
                            destinationTitle: 'Top Destinations',
                            socialTitle: 'Follow Marriott Bonvoy',
                            scrollImpression: 'false',
                            languageLable: 'English',
                            trackingTag1: 'US-universalFooter',
                            impressionCount: 'false',
                            merchandisingCategory: 'nonCobrand',
                            trackingLocation: 'universalFooter',
                            trackingOfferType: 'content',
                            trackingContentPosition: 'footer',
                            copyrightDescription:
                              '<p>© 1996 - 2025 Marriott International, Inc. All rights reserved. Marriott Proprietary Information</p>\r\n',
                            findHelpTitle: 'Find Help',
                            workWithUsTitle: 'Work With Us',
                            clickTrack: 'true',
                            destinationOnTop: 'false',
                          },
                          trackingProperties: {
                            enableScrollingBehavior: false,
                            trackingDescription: 'expandedFooter',
                            impressionTrack: false,
                            description: null,
                            trackingContentPosition: 'footer',
                            atCCeVar48: null,
                            clickTrack: true,
                            trackingTag2: null,
                            location: null,
                            trackingTag1: 'US-universalFooter',
                            merchandisingCategory: 'nonCobrand',
                            impressionCount: false,
                            trackingOfferType: 'content',
                            trackingTag: null,
                          },
                          destinationItems: [
                            {
                              linkLabel: 'New York Hotels',
                              openInaNewTab: 'false',
                              linkURL: '/en/destinations/nyc.mi',
                            },
                            {
                              linkLabel: 'Paris Hotels',
                              openInaNewTab: 'false',
                              linkURL: '/en/destinations/paris.mi',
                            },
                            {
                              linkLabel: 'Boston Hotels',
                              openInaNewTab: 'false',
                              linkURL: '/en/destinations/boston.mi',
                            },
                            {
                              linkLabel: 'San Diego Hotels',
                              openInaNewTab: 'false',
                              linkURL: '/en/destinations/san-diego.mi',
                            },
                            {
                              linkLabel: 'London Hotels',
                              openInaNewTab: 'false',
                              linkURL: '/en/destinations/london.mi',
                            },
                            {
                              linkLabel: 'Chicago Hotels',
                              openInaNewTab: 'false',
                              linkURL: '/en/destinations/chicago.mi',
                            },
                            {
                              linkLabel: 'San Francisco Hotels',
                              openInaNewTab: 'false',
                              linkURL: '/en/destinations/san-francisco.mi',
                            },
                            {
                              linkLabel: 'Nashville Hotels',
                              openInaNewTab: 'false',
                              linkURL: '/en/destinations/nashville.mi',
                            },
                            {
                              linkLabel: 'Washington DC Hotels',
                              openInaNewTab: 'false',
                              linkURL: '/en/destinations/washington-dc.mi',
                            },
                            {
                              linkLabel: 'New Orleans Hotels',
                              openInaNewTab: 'false',
                              linkURL: '/en/destinations/new-orleans.mi',
                            },
                            {
                              linkLabel: 'Orlando Hotels',
                              openInaNewTab: 'false',
                              linkURL: '/en/destinations/orlando.mi',
                            },
                            {
                              linkLabel: 'Las Vegas Hotels',
                              openInaNewTab: 'false',
                              linkURL: '/en/destinations/las-vegas.mi',
                            },
                            {
                              linkLabel: 'Denver Hotels',
                              openInaNewTab: 'false',
                              linkURL: '/en/destinations/denver.mi',
                            },
                            {
                              linkLabel: 'Los Angeles Hotels',
                              openInaNewTab: 'false',
                              linkURL: '/en/destinations/los-angeles.mi',
                            },
                            {
                              linkLabel: 'Miami Hotels',
                              openInaNewTab: 'false',
                              linkURL: '/en/destinations/miami.mi',
                            },
                            {
                              linkLabel: 'Toronto Hotels',
                              openInaNewTab: 'false',
                              linkURL: '/en/destinations/toronto.mi',
                            },
                            {
                              linkLabel: 'Miami Beach Hotels',
                              openInaNewTab: 'false',
                              linkURL: '/en/destinations/miami-beach.mi',
                            },
                            {
                              linkLabel: 'Phoenix Hotels',
                              openInaNewTab: 'false',
                              linkURL: '/en/destinations/phoenix.mi',
                            },
                            {
                              linkLabel: 'Sedona Hotels',
                              openInaNewTab: 'false',
                              linkURL: '/en/destinations/sedona.mi',
                            },
                            {
                              linkLabel: 'Santa Barbara Hotels',
                              openInaNewTab: 'false',
                              linkURL: '/en/destinations/santa-barbara.mi',
                            },
                            {
                              linkLabel: 'Charleston Hotels',
                              openInaNewTab: 'false',
                              linkURL: '/en/destinations/charleston-south-carolina.mi',
                            },
                            {
                              linkLabel: 'Island of Hawaii Hotels',
                              openInaNewTab: 'false',
                              linkURL: '/en/destinations/island-of-hawaii.mi',
                            },
                            {
                              linkLabel: 'Bahamas Hotels',
                              openInaNewTab: 'false',
                              linkURL: '/en/destinations/bahamas.mi',
                            },
                            {
                              linkLabel: 'Destin Hotels',
                              openInaNewTab: 'false',
                              linkURL: '/en/destinations/destin.mi',
                            },
                            {
                              linkLabel: 'Puerto Rico Hotels',
                              openInaNewTab: 'false',
                              linkURL: '/en/destinations/puerto-rico.mi',
                            },
                            {
                              linkLabel: 'Memphis Hotels',
                              openInaNewTab: 'false',
                              linkURL: '/en-us/destinations/united-states/tennessee/memphis.mi',
                            },
                            {
                              linkLabel: 'Oklahoma City Hotels',
                              openInaNewTab: 'false',
                              linkURL: '/en-us/destinations/united-states/oklahoma/oklahoma-city.mi',
                            },
                            {
                              linkLabel: 'View All Hotels',
                              openInaNewTab: 'false',
                              linkURL: '/hotel-sitemap.mi',
                            },
                          ],
                          path: '/content/dam/mi-aem-homepage-spa/language-selector-cf',
                          privacyItems: [
                            {
                              openInaNewTab: 'false',
                              htmlContent: '<span id="teconsent"></span>',
                            },
                            {
                              linkLabel: 'Privacy Center',
                              openInaNewTab: 'false',
                              linkURL: '/about/privacy.mi',
                            },
                            {
                              linkLabel: 'Your Privacy Choices',
                              openInaNewTab: 'false',
                              linkURL: '/about/your-privacy-rights.mi',
                              htmlContent:
                                '<img src="https://cache.marriott.com/aka-fonts/ccpa/privacyoptions29x14.png" data-src="https://cache.marriott.com/aka-fonts/ccpa/privacyoptions29x14.png" alt="Opt-out Icon" class="ca__full-width-img">',
                            },
                            {
                              linkLabel: 'Terms of Use',
                              openInaNewTab: 'false',
                              linkURL: '/about/terms-of-use.mi',
                            },
                            {
                              linkLabel: 'Program Terms & Conditions',
                              openInaNewTab: 'false',
                              linkURL: '/loyalty/terms/default.mi',
                            },
                            {
                              linkLabel: ' Sustainability in the Supply Chain',
                              openInaNewTab: 'false',
                              linkURL: '/marriott-brands/sustainabilitysupplychain.mi',
                            },
                          ],
                          ':type': 'mi-aem-homepage-spa/components/content/universal-footer',
                          workwithusItems: [
                            {
                              linkLabel: 'Small & Midsize Business Program',
                              openInaNewTab: 'false',
                              linkURL: '/programs/business-access-by-marriott-bonvoy.mi',
                            },
                            {
                              linkLabel: 'Travel Professionals',
                              openInaNewTab: 'false',
                              linkURL: 'https://www.travelagents.marriott.com/travelagents/default.mi',
                            },
                            {
                              linkLabel: 'Group Partners',
                              openInaNewTab: 'false',
                              linkURL: 'https://www.grouppartners.marriott.com/grouppartners/default.mi',
                            },
                            {
                              linkLabel: 'Hotel Development',
                              openInaNewTab: 'true',
                              linkURL: 'https://hotel-development.marriott.com/?stop_mobi=yes',
                            },
                            {
                              linkLabel: 'Affiliates',
                              openInaNewTab: 'false',
                              linkURL: '/marriott/affiliateprogram.mi',
                            },
                          ],
                          socialItems: [
                            {
                              openInaNewTab: 'true',
                              linkURL: 'https://www.facebook.com/marriottbonvoy',
                            },
                            {
                              openInaNewTab: 'true',
                              linkURL: 'https://www.instagram.com/marriottbonvoy/',
                            },
                            {
                              openInaNewTab: 'true',
                              linkURL: 'https://twitter.com/marriottbonvoy',
                            },
                            {
                              openInaNewTab: 'true',
                              linkURL: 'https://www.linkedin.com/company/marriott-international',
                            },
                            {
                              openInaNewTab: 'true',
                              linkURL: 'https://www.youtube.com/marriott',
                            },
                          ],
                          id: 'universal-footer-c2b789a687',
                        },
                      },
                      allowedComponents: {
                        components: [
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-homepage-spa/components/content/global-navigation',
                            title: 'Global Navigation',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-homepage-spa/components/content/universal-footer',
                            title: 'Universal Footer',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/accordioncontainer',
                            title: 'Accordion Container',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/accordioncontainerenhanced',
                            title: 'Accordion Container-Enhanced',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/apphomescreentakeover',
                            title: 'App Homescreen Takeover',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/apptileskinny',
                            title: 'App Tile Skinny',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/apptilesquare',
                            title: 'App Tile Square',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/bannerfeature',
                            title: 'Banner Feature',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/bannerlayered',
                            title: 'Banner Layered',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/bannertext',
                            title: 'Banner Text',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/brandribbon',
                            title: 'Brand Ribbon',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/card-mini-carousel-container',
                            title: 'Card Mini Carousel Container',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/cardcarouselcontainer',
                            title: 'Card Carousel Container',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/cardhorizontalfeature',
                            title: 'Card Horizontal Feature',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/cardhorizontalmini',
                            title: 'Card Horizontal Mini-Standard',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/cardlayered',
                            title: 'Card Layered',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/cardsummary',
                            title: 'Card Summary',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/cardvertical',
                            title: 'Card Vertical',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/carouselgallery',
                            title: 'Carousel Gallery',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/cobrandcardhorizontalflexible',
                            title: 'Cobrand-Card Horizontal Flexible',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-common-spa/components/contentfragment',
                            title: 'Content Fragment',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-common-spa/components/contentfragmentlist',
                            title: 'Content Fragment List',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/datablock',
                            title: 'Data Block',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-common-spa/components/experiencefragment',
                            title: 'Experience Fragment',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/generalmessage',
                            title: 'General Message',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/hero',
                            title: 'Hero',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/iconblock',
                            title: 'Icon Block',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/linkbanner',
                            title: 'Link Banner',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/linklist',
                            title: 'Link List',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/media',
                            title: 'Media',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/merchandisingherobanner',
                            title: 'Merchandising Hero Banner',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/merchandisingsmallbanner',
                            title: 'Merchandising Small Banner',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/mmn-container',
                            title: 'MMN Container',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/mosaic',
                            title: 'Mosaic',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/offersappcontainer',
                            title: 'Offers App Container',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-prearrival/components/richtext',
                            title: 'Rich Text',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/richtext',
                            title: 'Rich Text',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-common-spa/components/common/staticwrapper',
                            title: 'Static Wrapper',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/tabcontainer',
                            title: 'Tab Container',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/text',
                            title: 'Text',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/variablecolumncontainer',
                            title: 'Variable Column Container',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-shop-spa/components/content/autosuggestionblacklist/v1/autosuggestionblacklist',
                            title: 'Autosuggestion Blacklist',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-shop-spa/components/content/availabilitycalendar/v1/availabilitycalendar',
                            title: 'Availability Calendar component',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-shop-spa/components/content/baselinesearchform/v1/baselinesearchform',
                            title: 'Baseline Search Form',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-shop-spa/components/container',
                            title: 'Container',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-shop-spa/components/experiencefragment',
                            title: 'Experience Fragment',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-shop-spa/components/content/exploredestinations/v1/exploredestinations',
                            title: 'Explore Our Destinations Component',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-shop-spa/components/content/homepagesearch/v1/homepagesearch',
                            title: 'Homepage Search Form',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-shop-spa/components/content/hotelgalleryoverview',
                            title: 'Hotel Gallery overview',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-shop-spa/components/content/hotelgalleryphotoviewer',
                            title: 'Hotel Gallery Photo Viewer',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-shop-spa/components/content/hotelgallerytitle',
                            title: 'Hotel Gallery Title',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-shop-spa/components/content/hotelinformation',
                            title: 'Hotel information',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-shop-spa/components/content/hvmibanner/v1/hvmibanner',
                            title: 'HVMI Banner component',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-shop-spa/components/content/mapsubregion/v1/mapsubregion',
                            title: 'Map Sub Region Component',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-shop-spa/components/content/meetingssearchform/v1/meetingssearchform',
                            title: 'Meetings & Events Search Form',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-shop-spa/components/content/merchbanner/v1/merchbanner',
                            title: 'Merch Banner component',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-shop-spa/components/content/searchform/v1/searchform',
                            title: 'Search Form',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-shop-spa/components/content/searchresults/v1/searchresults',
                            title: 'Search Results component',
                          },
                          {
                            path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/responsivegrid/mi-aem-shop-spa/components/content/tabbedsearchformwrapper/v1/tabbedsearchformwrapper',
                            title: 'Tabbed Search Form Wrapper',
                          },
                        ],
                        applicable: false,
                      },
                      ':type': 'wcm/foundation/components/responsivegrid',
                      ':itemsOrder': ['universal_footer'],
                      columnClassNames: {
                        universal_footer: 'aem-GridColumn aem-GridColumn--default--12',
                      },
                      gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
                      columnCount: 12,
                    },
                  },
                  allowedComponents: {
                    components: [
                      {
                        path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/mi-aem-common-spa/components/content/accordioncontainer',
                        title: 'Accordion Container',
                      },
                      {
                        path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/mi-aem-common-spa/components/content/accordioncontainerenhanced',
                        title: 'Accordion Container-Enhanced',
                      },
                      {
                        path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/mi-aem-common-spa/components/content/apphomescreentakeover',
                        title: 'App Homescreen Takeover',
                      },
                      {
                        path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/mi-aem-common-spa/components/content/apptileskinny',
                        title: 'App Tile Skinny',
                      },
                      {
                        path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/mi-aem-common-spa/components/content/apptilesquare',
                        title: 'App Tile Square',
                      },
                      {
                        path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/mi-aem-common-spa/components/content/bannerfeature',
                        title: 'Banner Feature',
                      },
                      {
                        path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/mi-aem-common-spa/components/content/bannerlayered',
                        title: 'Banner Layered',
                      },
                      {
                        path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/mi-aem-common-spa/components/content/bannertext',
                        title: 'Banner Text',
                      },
                      {
                        path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/mi-aem-common-spa/components/content/brandribbon',
                        title: 'Brand Ribbon',
                      },
                      {
                        path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/mi-aem-common-spa/components/content/card-mini-carousel-container',
                        title: 'Card Mini Carousel Container',
                      },
                      {
                        path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/mi-aem-common-spa/components/content/cardcarouselcontainer',
                        title: 'Card Carousel Container',
                      },
                      {
                        path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/mi-aem-common-spa/components/content/cardhorizontalfeature',
                        title: 'Card Horizontal Feature',
                      },
                      {
                        path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/mi-aem-common-spa/components/content/cardhorizontalmini',
                        title: 'Card Horizontal Mini-Standard',
                      },
                      {
                        path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/mi-aem-common-spa/components/content/cardlayered',
                        title: 'Card Layered',
                      },
                      {
                        path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/mi-aem-common-spa/components/content/cardsummary',
                        title: 'Card Summary',
                      },
                      {
                        path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/mi-aem-common-spa/components/content/cardvertical',
                        title: 'Card Vertical',
                      },
                      {
                        path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/mi-aem-common-spa/components/content/carouselgallery',
                        title: 'Carousel Gallery',
                      },
                      {
                        path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/mi-aem-common-spa/components/content/cobrandcardhorizontalflexible',
                        title: 'Cobrand-Card Horizontal Flexible',
                      },
                      {
                        path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/mi-aem-common-spa/components/contentfragment',
                        title: 'Content Fragment',
                      },
                      {
                        path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/mi-aem-common-spa/components/contentfragmentlist',
                        title: 'Content Fragment List',
                      },
                      {
                        path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/mi-aem-common-spa/components/content/datablock',
                        title: 'Data Block',
                      },
                      {
                        path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/mi-aem-common-spa/components/experiencefragment',
                        title: 'Experience Fragment',
                      },
                      {
                        path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/mi-aem-common-spa/components/content/generalmessage',
                        title: 'General Message',
                      },
                      {
                        path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/mi-aem-common-spa/components/content/hero',
                        title: 'Hero',
                      },
                      {
                        path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/mi-aem-common-spa/components/content/iconblock',
                        title: 'Icon Block',
                      },
                      {
                        path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/mi-aem-common-spa/components/content/linkbanner',
                        title: 'Link Banner',
                      },
                      {
                        path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/mi-aem-common-spa/components/content/linklist',
                        title: 'Link List',
                      },
                      {
                        path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/mi-aem-common-spa/components/content/media',
                        title: 'Media',
                      },
                      {
                        path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/mi-aem-common-spa/components/content/merchandisingherobanner',
                        title: 'Merchandising Hero Banner',
                      },
                      {
                        path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/mi-aem-common-spa/components/content/merchandisingsmallbanner',
                        title: 'Merchandising Small Banner',
                      },
                      {
                        path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/mi-aem-common-spa/components/content/mmn-container',
                        title: 'MMN Container',
                      },
                      {
                        path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/mi-aem-common-spa/components/content/mosaic',
                        title: 'Mosaic',
                      },
                      {
                        path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/mi-aem-common-spa/components/content/offersappcontainer',
                        title: 'Offers App Container',
                      },
                      {
                        path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/mi-aem-prearrival/components/richtext',
                        title: 'Rich Text',
                      },
                      {
                        path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/mi-aem-common-spa/components/content/richtext',
                        title: 'Rich Text',
                      },
                      {
                        path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/mi-aem-common-spa/components/common/staticwrapper',
                        title: 'Static Wrapper',
                      },
                      {
                        path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/mi-aem-common-spa/components/content/tabcontainer',
                        title: 'Tab Container',
                      },
                      {
                        path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/mi-aem-common-spa/components/content/text',
                        title: 'Text',
                      },
                      {
                        path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/mi-aem-common-spa/components/content/variablecolumncontainer',
                        title: 'Variable Column Container',
                      },
                      {
                        path: '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content/root/mi-aem-common-spa/components/form/container',
                        title: 'Core Form Container',
                      },
                    ],
                    applicable: false,
                  },
                  ':type': 'wcm/foundation/components/responsivegrid',
                  ':itemsOrder': ['responsivegrid'],
                  columnClassNames: {
                    responsivegrid: 'aem-GridColumn aem-GridColumn--default--12',
                  },
                  gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
                  columnCount: 12,
                },
              },
              localizedFragmentVariationPath:
                '/content/experience-fragments/mi-aem-common-spa/na/en-us/universal-footer/master/jcr:content',
              ':type': 'mi-aem-common-spa/components/experiencefragment',
              dataLayer: {
                'experiencefragment-6533758dd6': {
                  '@type': 'mi-aem-common-spa/components/experiencefragment',
                  'repo:modifyDate': '2025-04-18T09:01:10Z',
                },
              },
              ':itemsOrder': ['root', 'cq:metadata'],
              classNames: 'aem-xf',
              id: 'experiencefragment-6533758dd6',
            },
            merchbanner: {
              ':type': 'mi-aem-shop-spa/components/content/merchbanner/v1/merchbanner',
              dataLayer: {
                'merchbanner-ebb4981bb2': {
                  '@type': 'mi-aem-shop-spa/components/content/merchbanner/v1/merchbanner',
                  'repo:modifyDate': '2025-04-18T09:01:10Z',
                },
              },
              id: 'merchbanner-ebb4981bb2',
            },
            staticwrapper_copy: {
              ':type': 'mi-aem-common-spa/components/common/staticwrapper',
              dataLayer: {
                'staticwrapper-9729c1020c': {
                  '@type': 'mi-aem-common-spa/components/common/staticwrapper',
                  'repo:modifyDate': '2025-04-18T09:01:10Z',
                },
              },
              referencePath:
                '\n\n\n\n    <div class="root container responsivegrid">\n\n    \n    <div id="container-3e49ef5c96" class="cmp-container">\n        \n\n\n<div class="aem-Grid aem-Grid--12 aem-Grid--default--12 ">\n    \n    <div class="header aem-GridColumn aem-GridColumn--default--12">\n\n    \n    <header class="m-header standard user-thin-bar" data-api-endpoint="/hybrid-presentation/api/v1/getUserDetails">\n        <div class="m-dark-overlay no-display"></div>\n        <div class="m-header__thin-container">\n            <div class="m-header__black-strip"></div>\n            <div class="m-header__thin-content container-lg">\n                <div class="m-header__logo-nav-items">\n                    <div class="m-header__thin-logo-wrap inverse">\n                        <a href="/default.mi" class="m-header__thin-logo-icon t-program-logo-color-thin">\n                            <span class="sr-only">Marriott Bonvoy</span>\n                        </a>\n                    </div>\n                    <div class="m-header__all-links">\n                        <nav class="m-header__thin-top-nav thin-r-upper">\n                            \n    \n    <ul class="m-header__top-links">\n        \n        \n            \n              <li class="  t-global-nav-items font-nav-items first-set-list-items ">\n    <a href="https://help.marriott.com/s/" class="m-header__btn m-header__top-nav-btn custom_click_track  " data-location-text="Thin Global Nav" data-click-track-enable="true" data-mytrip-label="My Trips" data-custom_click_track_value="Thin Global Nav|Help|external">\n      <span class="m-header__top-nav-icon icon-thin icon-help"></span><span class="m-header__top-nav-txt  txt-thin d-none d-md-block">Help</span>\n      \n      \n    </a>\n    \n    \n  </li>\n\n        \n          <li class="  t-global-nav-items m-header__my-trip font-nav-items last-list-item ">\n    \n    <a href="#" role="button" class="m-header__btn m-header__top-nav-btn m-dialog-btn custom_click_track   m-header__top-nav-btn" data-dialog-id="m-header-mytrip-dialog-header_copy" data-overlay-endpoint="/resLookupOverlay.mi" data-loading-msg="Loading..." data-error-msg="The content could not be loaded" data-location-text="Thin Global Nav" data-click-track-enable="true" data-custom_click_track_value="Thin Global Nav|My Trips|internal" data-authenticated-url="/rewards/findReservationList.mi" data-sign-in-click-track-enabled="true" data-remembered-user-location="signin_rem_tooltip" data-mytrip-label="My Trips" data-signed-in-user-location="Logged-in User">\n      <span class="m-header__top-nav-icon icon-thin icon-nav---trips"></span><span class="m-header__top-nav-txt txt-thin d-lg-block">My Trips</span>\n    </a>\n    \n  </li>\n\n        \n          <li class="  m-header__sign-in t-global-nav-items font-nav-items " data-sign-in-text="Sign In,">\n    \n    <a href="#" role="button" class="m-header__btn m-header__top-nav-btn m-dialog-btn custom_click_track   m-header__top-nav-btn" aria-label="Sign In or Join" data-dialog-id="m-header-signin-dialog-header_copy" data-overlay-endpoint="/signInOverlay.mi" data-loading-msg="Loading..." data-error-msg="The content could not be loaded" data-location-text="Thin Global Nav" data-click-track-enable="true" data-custom_click_track_value="Thin Global Nav|Sign In or Join|internal" data-sign-in-click-track-enabled="true" data-remembered-user-location="signin_rem_tooltip" data-mytrip-label="My Trips" data-signed-in-user-location="Logged-in User">\n      <span class="m-header__top-nav-icon icon-thin icon-nav---account"></span><span class="m-header__top-nav-txt txt-thin d-lg-block">Sign In or Join</span>\n    </a>\n    \n  </li>\n\n        \n          <li class="  d-none m-header__sign-in m-header__sign-in-tooltip t-global-nav-items font-nav-items " data-sign-in-text="Sign In,">\n    \n    <a href="#" role="button" class="m-header__btn m-header__top-nav-btn m-dialog-btn custom_click_track   " aria-label="Sign In or Join" aria-expanded="true" aria-controls="sign-in-tooltip-id" data-overlay-endpoint="/signInOverlay.mi" data-loading-msg="Loading..." data-error-msg="The content could not be loaded" data-location-text="signin_anon_tooltip" data-click-track-enable="true" data-custom_click_track_value="signin_anon_tooltip|Sign In or Join|internal" data-sign-in-click-track-enabled="true" data-remembered-user-location="signin_rem_tooltip" data-mytrip-label="My Trips" data-signed-in-user-location="Logged-in User">\n      <span class="m-header__top-nav-icon icon-thin icon-nav---account"></span><span class="m-header__top-nav-txt txt-thin d-lg-block">Sign In or Join</span>\n    </a>\n    \n  \n  <div class="m-header-tool-tip">\n    <div class="sign-in-tool-tip carrot-icon" id="sign-in-tooltip-id" data-configuration-time="10">\n      <button class="signin-btn t-subtitle-l custom_click_track" data-click-track-enable="true" data-location-text="signin_rem_tooltip" data-description="Sign In" data-custom_click_track_value="signin_anon_tooltip|Sign In|internal">Sign In\n        <span class="icon-arrow-right"></span>\n      </button>\n      <a class="join-btn t-subtitle-l custom_click_track" href="/loyalty/createAccount/createAccountPage1.mi" data-click-track-enable="true" data-location-text="signin_rem_tooltip" data-description="Join" data-custom_click_track_value="signin_anon_tooltip|Join|internal">\n        Join<span class="icon-arrow-right"></span>\n      </a>\n    </div>\n    <div class="m-header__sign-in-model carrot-icon sign-in d-none">\n      <div class="loading"><div class="loader"></div></div>\n      <p class="model-heading t-subtitle-l">\n        Sign In to your account<button type="button" class="icon-clear">\n          <span class="sr-only">Close Dialog</span>\n        </button>\n      </p>\n        <form method="post" name="directLoginForm" action="/aries-auth/loginWithCredentials.comp" class="s-form" data-submit-to-phoenix="false">\n        <input type="hidden" class="sign-in-return-url" name="returnUrl" value=""/>\n        <input type="hidden" name="errorUrl" value="/sign-in-error.mi"/>\n        <div class="input-container s-form__user-input">\n          <label class="t-label-xs form-label" for="signin-userid">Email or Member Number</label>\n          <input type="text" id="signin-userid" name="userID" autocomplete="off" class="t-subtitle-l"/>\n        </div>\n        <div class="input-container s-form__remember-input d-none">\n          <label class="t-label-xs form-label" for="sign-rem-user-number">\n            Email or Member Number\n          </label>\n          <input type="text" id="sign-rem-user-number" name="memberNumber" autocomplete="off" class="t-subtitle-l s-form__member-number" readonly/>\n        </div>\n        <div class="input-container">\n          <label class="t-label-xs form-label" for="signin-user-password">Password</label>\n          <input type="password" id="signin-user-password" autocomplete="off" name="password" class="t-subtitle-l"/>\n        </div>\n        <div class="sign-in-wrapper">\n          <div class="remember-me">\n            <input name="rememberMe" type="checkbox" id="signin-rememberme" value="true" checked/>\n            <label for="signin-rememberme" class="remember-label t-font-xs">\n              Remember Me\n            </label>\n          </div>\n          <button type="submit" class="login-link m-button-s m-button-primary custom_click_track" data-click-track-enable="true" data-location-text="signin_rem_tooltip" data-description="Sign In" data-custom_click_track_value="signin_anon_tooltip|Sign In|internal">\n            Sign In\n          </button>\n        </div>\n        <div class="links-container">\n          <a href="/forgotPassword.mi" class="s-form__forgot-psd t-label-xs custom_click_track" data-click-track-enable="true" data-location-text="signin_rem_tooltip" data-description="Forgot Password" data-custom_click_track_value="signin_anon_tooltip|Forgot Password|internal">Forgot Password</a>\n          <span class="divider t-label-xs">|</span>\n          <a href="/aries-auth/clearRememberMe.comp" class="s-form__clear-remember custom_click_track t-label-xs d-none" data-click-track-enable="true" data-location-text="signin_rem_tooltip" data-description="Clear Remembered Account" data-custom_click_track_value="signin_anon_tooltip|Clear Remembered Account|internal">Clear Remembered Account</a>\n          <a href="/loyalty/createAccount/activateAccountChallenge.mi" class="custom_click_track s-form__activate_acnt t-label-xs" data-click-track-enable="true" data-location-text="signin_rem_tooltip" data-description="Activate online account" data-custom_click_track_value="signin_anon_tooltip|Activate online account|internal">Activate online account</a>\n        </div>\n      </form>\n    </div>\n  </div>\n\n  </li>\n\n          <li class="  m-header__points t-global-nav-items font-nav-items points-thin d-none member-R " data-point-text="Point" data-points-text="Points" data-night-text="Night" data-nights-text="nights" data-hello-text="Hello,">\n    <a href="/loyalty/myAccount/activity.mi" class="m-header__btn m-header__top-nav-btn custom_click_track  " data-mytrip-label="My Trips">\n      <span class="m-header__top-nav-icon icon-thin icon-buy-points d-none d-md-block"></span><span class="m-header__top-nav-icon icon-thin icon-buy-points d-none"></span><span class="m-header__top-nav-txt  txt-thin d-none d-md-block">Points</span>\n      \n      \n    </a>\n    \n    \n  </li>\n\n        \n        <!-- default label is set to "i18nSignIn" to remove Wave Tool error of empty link. -->\n          <li class=" d-none m-header__acnt t-global-nav-items font-nav-items " data-hello-text="Hello,">\n    <a href="/loyalty/myAccount/default.mi" class="m-header__btn m-header__top-nav-btn custom_click_track m-header__top-nav-btn--account " data-location-text="Logged-in User" data-click-track-enable="true" data-mytrip-label="My Trips" data-custom_click_track_value="Logged-in User|SIGN IN|external">\n      <span class="m-header__top-nav-icon icon-thin icon-nav---account-alt-active icon-inverse member-R"></span><span class="m-header__top-nav-icon icon-thin icon-nav---account-alt-active d-none"></span><span class="m-header__top-nav-txt  txt-thin d-none d-md-block">SIGN IN</span>\n      \n      \n    </a>\n    \n    \n  </li>\n\n    </ul>\n\n                        </nav>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </header>\n    \n    \n    \n    \n    <div class="mdc-dialog " id="m-header-signin-dialog-header_copy">\n        <div class="mdc-dialog__container">\n            <div class="mdc-dialog__surface" role="dialog" aria-modal="true">\n                <button class="m-dialog-close-btn icon-clear">\n                    <span class="sr-only">Close Dialog</span>\n                </button>\n                \n\n    \n    <div id="container-2b2d95f37f" class="cmp-container">\n        \n\n\n<div class="aem-Grid aem-Grid--12 aem-Grid--default--12 ">\n    \n    <div class="signin aem-GridColumn aem-GridColumn--default--12"><div class="modal-content mfp-content header-overlay standard standard">\n  <div class="header-overlay__msg"></div>\n</div>\n</div>\n\n    \n</div>\n\n    </div>\n\n    \n\n            </div>\n            <div class="mdc-dialog__scrim"></div>\n        </div>\n    </div>\n\n    \n    <div class="mdc-dialog " id="m-header-mytrip-dialog-header_copy">\n        <div class="mdc-dialog__container">\n            <div class="mdc-dialog__surface" role="dialog" aria-modal="true">\n                <button class="m-dialog-close-btn icon-clear">\n                    <span class="sr-only">Close Dialog</span>\n                </button>\n                \n\n    \n    <div id="container-06351e7332" class="cmp-container">\n        \n\n\n<div class="aem-Grid aem-Grid--12 aem-Grid--default--12 ">\n    \n    <div class="signin aem-GridColumn aem-GridColumn--default--12"><div class="modal-content mfp-content header-overlay standard standard">\n  <div class="header-overlay__msg"></div>\n</div>\n</div>\n\n    \n</div>\n\n    </div>\n\n    \n\n            </div>\n            <div class="mdc-dialog__scrim"></div>\n        </div>\n    </div>\n\n    \n    \n    \n        \n        \n    \n    \n    <div class="mdc-dialog mp__modal" id="member-panel-dialog">\n        <div class="mdc-dialog__container">\n            <div class="mdc-dialog__surface" role="dialog" aria-modal="true">\n                <button class="m-dialog-close-btn icon-clear">\n                    <span class="sr-only">Close Dialog</span>\n                </button>\n                \n\n    \n    <div id="container-6a905e3bb3" class="cmp-container">\n        \n\n\n<div class="aem-Grid aem-Grid--12 aem-Grid--default--12 ">\n    \n    <div class="memberpanel aem-GridColumn aem-GridColumn--default--12"><div class="mp">\n    \n    \n    <div class="mp__container">\n        <div class="mp__member-details">\n            <div class="mp__member-profile">\n                <div class="mp__member-icon">\n                    <img src="https://cache.marriott.com/marriottassets/icons/mrw_default_profile_placeholder1.png" alt="Generic profile"/>\n                </div>\n                <div class="mp__member-level t-subtitle-m"></div>\n                <div class="mp__member-name t-title-s"></div>\n            </div>\n            <div class="mp__member-points-section">\n                <span class="t-subtitle-xl mp__member-points">0</span>\n                <span class="t-overline-normal mp__member-points-text">Points</span>\n                <a class="m-button-s m-button-external mp__buy-points-btn custom_click_track" href="https://marriott.pxf.io/c/2821611/321374/4937" target="_blank" rel="noopener noreferrer" data-custom_click_track_value="Buy Points|Buy Points|internal">\n                    Buy Points\n                    <span class="sr-only">Opens a new window</span>\n                </a>\n            </div>\n        </div>\n        <div class="mp__subnav">\n            \n<div class="cl ">\n\n  \n\n  \n  \n\n  \n  <div class="cl__label-only">\n    <ul class="cl__list">\n      <li class="cl__list-item">\n        <a class="cl__item-link t-subtitle-m custom_click_track" href="/loyalty/myAccount/default.mi" data-custom_click_track_value="Overview|Overview|internal">Overview\n          \n        </a>\n      </li>\n<li class="cl__list-item">\n        <a class="cl__item-link t-subtitle-m custom_click_track" href="/loyalty/myAccount/activity.mi" data-custom_click_track_value="Activity|Activity|internal">Activity\n          \n        </a>\n      </li>\n<li class="cl__list-item">\n        <a class="cl__item-link t-subtitle-m custom_click_track" href="/loyalty/findReservationList.mi" data-custom_click_track_value="My Trips|My Trips|internal">My Trips\n          \n        </a>\n      </li>\n<li class="cl__list-item">\n        <a class="cl__item-link t-subtitle-m custom_click_track" href="/loyalty/myAccount/savedHotels.mi" data-custom_click_track_value="Favorites|Favorites|internal">Favorites\n          \n        </a>\n      </li>\n<li class="cl__list-item">\n        <a class="cl__item-link t-subtitle-m custom_click_track" href="/loyalty/promotionCentral.mi" data-custom_click_track_value="Promotions|Promotions|internal">Promotions\n          \n        </a>\n      </li>\n<li class="cl__list-item">\n        <a class="cl__item-link t-subtitle-m custom_click_track" href="/loyalty/myAccount/profile.mi" data-custom_click_track_value="Profile|Profile|internal">Profile\n          \n        </a>\n      </li>\n<li class="cl__list-item">\n        <a class="cl__item-link t-subtitle-m custom_click_track" href="/loyalty/promotionCentral.mi" data-custom_click_track_value="Member Benefits|Member Benefits|internal">Member Benefits\n          \n        </a>\n      </li>\n\n    </ul>\n  </div>\n\n</div>\n\n    \n\n            <a class="mp__member-logout t-label-inverse-alt-xs icon-arrow-right custom_click_track" data-custom_click_track_value="SIGN OUT|SIGN OUT|internal}" href="/aries-auth/logout.comp">SIGN OUT</a>\n        </div>\n        \n\n\n\n\n    \n    \n    <div class="minicards">\n<section class="cb cb-memberpanel container-sm ">\n    \n    \n    <div class="row">\n        \n        \n        \n        \n        <div class="cb__simple  col-12">\n            \n                \n            \n            <a class="cb__container custom_click_track modal-track-link icon-arrow-right" href="https://marriott.com/credit-cards.mi" data-is-co-brand="false" data-is-click-track="true" data-is-impression-track="false" data-is-impression-count="false" data-custom_click_track_value="Marriott Bonvoy™ Credit Cards|Marriott Bonvoy™ Credit Cards|internal">\n                <div class="col-12 cb__content cb__chevron">\n                    \n                    \n                    \n\n                    <div class="lazy-image cb__img  ">\n                        <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR4nGNiOAMAANUAz5n+TlUAAAAASUVORK5CYII=" data-src="/content/dam/marriott-digital/digital-merchandising/global/en_us/cobrand-cards/assets/pdt-NRPC-cardsIcon-252x159-881844201519841.png" alt=" Illustration of 3 fanned out credit cards" loading="lazy"/>\n                    </div>\n                    <div class="cb__copy">\n                        <h2 class="t-subtitle-l d-none d-md-block">Marriott Bonvoy™ Credit Cards</h2>\n                            \n                        <h2 class="t-subtitle-l d-block d-md-none">Marriott Bonvoy™ Credit Cards</h2>\n                            \n                    </div>\n                </div>\n                \n            </a>\n        </div>\n    </div>\n</section>\n\n\n\n\n\n    \n\n</div>\n\n\n\n        <span class="mp__member-benefits d-none" data-member-data="[{&#34;linkLabel&#34;:&#34;Member Benefits&#34;,&#34;linkPath&#34;:&#34;/loyalty/member-benefits/member.mi&#34;,&#34;openInaNewTab&#34;:&#34;&#34;,&#34;memberType&#34;:&#34;R&#34;},{&#34;linkLabel&#34;:&#34;Gold Elite Benefits&#34;,&#34;linkPath&#34;:&#34;/loyalty/member-benefits/gold.mi&#34;,&#34;openInaNewTab&#34;:&#34;&#34;,&#34;memberType&#34;:&#34;G&#34;},{&#34;linkLabel&#34;:&#34;Silver Elite Benefits&#34;,&#34;linkPath&#34;:&#34;/loyalty/member-benefits/silver.mi&#34;,&#34;openInaNewTab&#34;:&#34;&#34;,&#34;memberType&#34;:&#34;S&#34;},{&#34;linkLabel&#34;:&#34;Platinum Elite Benefits&#34;,&#34;linkPath&#34;:&#34;/loyalty/member-benefits/platinum.mi&#34;,&#34;openInaNewTab&#34;:&#34;&#34;,&#34;memberType&#34;:&#34;P&#34;},{&#34;linkLabel&#34;:&#34;Ambassador Elite Benefits&#34;,&#34;linkPath&#34;:&#34;/loyalty/member-benefits/ambassador.mi&#34;,&#34;openInaNewTab&#34;:&#34;&#34;,&#34;memberType&#34;:&#34;PPAE&#34;},{&#34;linkLabel&#34;:&#34;Titanium Elite Benefits&#34;,&#34;linkPath&#34;:&#34;/loyalty/member-benefits/titanium.mi&#34;,&#34;openInaNewTab&#34;:&#34;&#34;,&#34;memberType&#34;:&#34;PPE&#34;}]">​​​​​​</span>\n    </div>\n</div></div>\n\n    \n</div>\n\n    </div>\n\n    \n\n            </div>\n            <div class="mdc-dialog__scrim"></div>\n        </div>\n    </div>\n\n    <script>\n        window.MI_S2_RESOURCE_BASE_URL = "/aries/595728aa4/standards/js/";\n        window.MI_S2_ARIES_CSS_LIST = [\'/aries/595728aa4/standards/css/foundation.css\'];\n        window.MI_S2_ARIES_JS_LIST = [\'/aries/components/mi-vendor/mi-vendor.js\', \'/aries/components/mi-core/mi-core.js\', \'/aries/components/mi-common/mi-common.js\', \'/aries/standards/js/mi-foundation.js\'];\n        window.MI_S2_MI_APP_URL = "/aries/resolver/mi-app/mi-app.js";\n    </script>\n    <script src="/aries/components/mi-vendor/mi-vendor.js" defer></script>\n    <script src="/aries/components/mi-core/mi-core.js" defer></script>\n    <script src="/aries/components/mi-common/mi-common.js" defer></script>\n    <script src="/aries/standards/js/mi-foundation.js" defer></script>\n    \n    <form anonymous-action="/mi/phoenix-account-auth/v1/sessionTimeOut" loggedIn-action="/mi/phoenix-account-auth/v1/sessionTimeOut" class="d-none session-timeout">\n    <input type="hidden" name="expiredIn" value="1800000"/>\n</form>\n\n    \n    \n\n\n\n\n\n\n\n</div>\n\n    \n</div>\n\n    </div>\n\n    \n',
              fragmentPath:
                '/content/experience-fragments/mcom-common/global/en-us/headerv1/header-experience-fragment/slim-header.html',
              id: 'staticwrapper-9729c1020c',
            },
          },
          allowedComponents: {
            components: [
              {
                path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/responsivegrid/mi-aem-shop-spa/components/content/autosuggestionblacklist/v1/autosuggestionblacklist',
                title: 'Autosuggestion Blacklist',
              },
              {
                path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/responsivegrid/mi-aem-shop-spa/components/content/availabilitycalendar/v1/availabilitycalendar',
                title: 'Availability Calendar component',
              },
              {
                path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/responsivegrid/mi-aem-shop-spa/components/content/baselinesearchform/v1/baselinesearchform',
                title: 'Baseline Search Form',
              },
              {
                path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/responsivegrid/mi-aem-shop-spa/components/container',
                title: 'Container',
              },
              {
                path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/responsivegrid/mi-aem-shop-spa/components/experiencefragment',
                title: 'Experience Fragment',
              },
              {
                path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/responsivegrid/mi-aem-shop-spa/components/content/exploredestinations/v1/exploredestinations',
                title: 'Explore Our Destinations Component',
              },
              {
                path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/responsivegrid/mi-aem-shop-spa/components/content/homepagesearch/v1/homepagesearch',
                title: 'Homepage Search Form',
              },
              {
                path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/responsivegrid/mi-aem-shop-spa/components/content/hotelgalleryoverview',
                title: 'Hotel Gallery overview',
              },
              {
                path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/responsivegrid/mi-aem-shop-spa/components/content/hotelgalleryphotoviewer',
                title: 'Hotel Gallery Photo Viewer',
              },
              {
                path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/responsivegrid/mi-aem-shop-spa/components/content/hotelgallerytitle',
                title: 'Hotel Gallery Title',
              },
              {
                path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/responsivegrid/mi-aem-shop-spa/components/content/hotelinformation',
                title: 'Hotel information',
              },
              {
                path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/responsivegrid/mi-aem-shop-spa/components/content/hvmibanner/v1/hvmibanner',
                title: 'HVMI Banner component',
              },
              {
                path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/responsivegrid/mi-aem-shop-spa/components/content/mapsubregion/v1/mapsubregion',
                title: 'Map Sub Region Component',
              },
              {
                path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/responsivegrid/mi-aem-shop-spa/components/content/meetingssearchform/v1/meetingssearchform',
                title: 'Meetings & Events Search Form',
              },
              {
                path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/responsivegrid/mi-aem-shop-spa/components/content/merchbanner/v1/merchbanner',
                title: 'Merch Banner component',
              },
              {
                path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/responsivegrid/mi-aem-shop-spa/components/content/searchform/v1/searchform',
                title: 'Search Form',
              },
              {
                path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/responsivegrid/mi-aem-shop-spa/components/content/searchresults/v1/searchresults',
                title: 'Search Results component',
              },
              {
                path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/responsivegrid/mi-aem-shop-spa/components/content/tabbedsearchformwrapper/v1/tabbedsearchformwrapper',
                title: 'Tabbed Search Form Wrapper',
              },
              {
                path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/responsivegrid/mcom-book-spa/components/prebooking/hotelheader',
                title: 'Hotel Header',
              },
              {
                path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/linkbanner',
                title: 'Link Banner',
              },
              {
                path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/responsivegrid/mi-aem-common-spa/components/common/staticwrapper',
                title: 'Static Wrapper',
              },
              {
                path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/merchandisingsmallbanner',
                title: 'Merchandising Small Banner',
              },
              {
                path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/responsivegrid/wcm/foundation/components/responsivegrid',
                title: 'Layout Container',
              },
              {
                path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/responsivegrid/mi-aem-common-spa/components/experiencefragment',
                title: 'Experience Fragment',
              },
              {
                path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/cardlayered',
                title: 'Card Layered',
              },
              {
                path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/cardcarouselcontainer',
                title: 'Card Carousel Container',
              },
            ],
            applicable: false,
          },
          ':type': 'wcm/foundation/components/responsivegrid',
          ':itemsOrder': [
            'staticwrapper_copy',
            'hotelheader_copy',
            'searchform_copy',
            'availabilitycalendar',
            'experiencefragment',
            'merchbanner',
            'merchbanner_696367081',
          ],
          columnClassNames: {
            merchbanner_696367081: 'aem-GridColumn aem-GridColumn--default--12',
            availabilitycalendar: 'aem-GridColumn aem-GridColumn--default--12',
            hotelheader_copy: 'aem-GridColumn aem-GridColumn--default--12',
            searchform_copy: 'aem-GridColumn aem-GridColumn--default--12',
            experiencefragment: 'aem-GridColumn aem-GridColumn--default--12',
            merchbanner: 'aem-GridColumn aem-GridColumn--default--12',
            staticwrapper_copy: 'aem-GridColumn aem-GridColumn--default--12',
          },
          gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
          columnCount: 12,
        },
      },
      allowedComponents: {
        components: [
          {
            path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/mi-aem-shop-spa/components/content/autosuggestionblacklist/v1/autosuggestionblacklist',
            title: 'Autosuggestion Blacklist',
          },
          {
            path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/mi-aem-shop-spa/components/content/availabilitycalendar/v1/availabilitycalendar',
            title: 'Availability Calendar component',
          },
          {
            path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/mi-aem-shop-spa/components/content/baselinesearchform/v1/baselinesearchform',
            title: 'Baseline Search Form',
          },
          {
            path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/mi-aem-shop-spa/components/container',
            title: 'Container',
          },
          {
            path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/mi-aem-shop-spa/components/experiencefragment',
            title: 'Experience Fragment',
          },
          {
            path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/mi-aem-shop-spa/components/content/exploredestinations/v1/exploredestinations',
            title: 'Explore Our Destinations Component',
          },
          {
            path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/mi-aem-shop-spa/components/content/homepagesearch/v1/homepagesearch',
            title: 'Homepage Search Form',
          },
          {
            path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/mi-aem-shop-spa/components/content/hotelgalleryoverview',
            title: 'Hotel Gallery overview',
          },
          {
            path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/mi-aem-shop-spa/components/content/hotelgalleryphotoviewer',
            title: 'Hotel Gallery Photo Viewer',
          },
          {
            path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/mi-aem-shop-spa/components/content/hotelgallerytitle',
            title: 'Hotel Gallery Title',
          },
          {
            path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/mi-aem-shop-spa/components/content/hotelinformation',
            title: 'Hotel information',
          },
          {
            path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/mi-aem-shop-spa/components/content/hvmibanner/v1/hvmibanner',
            title: 'HVMI Banner component',
          },
          {
            path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/mi-aem-shop-spa/components/content/mapsubregion/v1/mapsubregion',
            title: 'Map Sub Region Component',
          },
          {
            path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/mi-aem-shop-spa/components/content/meetingssearchform/v1/meetingssearchform',
            title: 'Meetings & Events Search Form',
          },
          {
            path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/mi-aem-shop-spa/components/content/merchbanner/v1/merchbanner',
            title: 'Merch Banner component',
          },
          {
            path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/mi-aem-shop-spa/components/content/searchform/v1/searchform',
            title: 'Search Form',
          },
          {
            path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/mi-aem-shop-spa/components/content/searchresults/v1/searchresults',
            title: 'Search Results component',
          },
          {
            path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/mi-aem-shop-spa/components/content/tabbedsearchformwrapper/v1/tabbedsearchformwrapper',
            title: 'Tabbed Search Form Wrapper',
          },
          {
            path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/mcom-book-spa/components/prebooking/hotelheader',
            title: 'Hotel Header',
          },
          {
            path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/mi-aem-common-spa/components/content/linkbanner',
            title: 'Link Banner',
          },
          {
            path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/mi-aem-common-spa/components/common/staticwrapper',
            title: 'Static Wrapper',
          },
          {
            path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/mi-aem-common-spa/components/content/merchandisingsmallbanner',
            title: 'Merchandising Small Banner',
          },
          {
            path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/wcm/foundation/components/responsivegrid',
            title: 'Layout Container',
          },
          {
            path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/mi-aem-common-spa/components/experiencefragment',
            title: 'Experience Fragment',
          },
          {
            path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/mi-aem-common-spa/components/content/cardlayered',
            title: 'Card Layered',
          },
          {
            path: '/content/marriott-shop-spa/na/en-us/availabilityCalendar/jcr:content/root/mi-aem-common-spa/components/content/cardcarouselcontainer',
            title: 'Card Carousel Container',
          },
        ],
        applicable: false,
      },
      ':type': 'wcm/foundation/components/responsivegrid',
      ':itemsOrder': ['responsivegrid'],
      columnClassNames: {
        responsivegrid: 'aem-GridColumn aem-GridColumn--default--12',
      },
      gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
      columnCount: 12,
    },
  },
  cqItemsOrder: ['root'],
  templateName: 'headless-next-js-template',
  cqPath: '/content/marriott-shop-spa/na/en-us/availabilityCalendar',
  staticComponentClientLibsJS: '/etc.clientlibs/mi-aem-shop-spa/clientlibs/clientlib-static-component.min.js',
  gridCss: '/etc.clientlibs/mi-aem-shop-spa/clientlibs/clientlib-base.css',
  metaProperties: [
    {
      name: 'og:title',
      value: '',
    },
    {
      name: 'og:description',
      value: '',
    },
    {
      name: 'og:image',
      value: '',
    },
    {
      name: 'og:type',
      value: '',
    },
    {
      name: 'og:site_name',
      value: '',
    },
    {
      name: 'fbAppId',
      value: '',
    },
    {
      name: 'og:url',
      value: '',
    },
  ],
  designPath: '/libs/settings/wcm/designs/default',
};
